/**
 * event-container.js
 */

import React from 'react';
import {
  useHistory,
} from "react-router-dom";
import { parse } from 'date-fns';
import { Types } from 'utils/constants';
import { dateParamFormat } from 'utils/datetime';
import { makeLocation } from 'utils/routing';
import useRecordStore from 'contexts/record-store';
import EventEdit from '../edit';
import EventSelect from '../select';


export default function EventContainer(props) {
  const {
    basePath,
    params,
  } = props;
  const history = useHistory();
  const recordStore = useRecordStore();
  const [selectedTab, setSelectedTab] = React.useState();
  const eventId = params?.id;
  const action = params?.action;

  // find number of events on selected date
  const dateParam = new URLSearchParams(window.location.search).get('date');
  const selectedDate = dateParam
    ? parse(dateParam, dateParamFormat, new Date())
    : new Date();
  const selectedDateState = recordStore.useDate(selectedDate).ornull;  
  const selectedDateEvents = selectedDateState
    ? selectedDateState.records.get().filter(r => r.recordType === Types.Record.EVENT) 
    : [];
  const selectedDateEventCount = dateParam && selectedDateEvents ? selectedDateEvents.length : 0;


  // determine tab from provided eventId and available events
  React.useEffect(() => {
    if (action === 'init') {
      history.replace(makeLocation(
        basePath,
        'training',
        selectedDateEventCount > 0 ? 'wizardSelectEvent' : 'wizardCreateEvent',
        { eventId: 0 },
        history.location,
        dateParam ? { date: dateParam } : null
      ));
    } else if (action === 'create') {
      setSelectedTab('new');
    } else if (action === 'select') {
      setSelectedTab('existing');
    }
  }, [eventId, action, selectedDateEventCount, basePath, history, dateParam]);


  return (
    <>
      {selectedTab &&
      <>
        {/* event editor */}
        {selectedTab === 'new' &&
        <EventEdit {...props} />}

        {/* event selector */}
        {selectedTab === 'existing' &&
        <EventSelect {...props} />}
      </>}
    </>
  );
}